import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withTranslate } from 'react-redux-multilingual'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import TextField from '@material-ui/core/TextField'
import Fab from '@material-ui/core/Fab'
import ExpandMoreIcon from '@material-ui/icons/NavigateNext'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'

function FindReservationByEmailCard({
  classes,
  translate,
  searchEmail,
  error,
  errorText,
  reservationLoaded,
  reservationList,
  onChangeSearchEmail,
  onKeyPress,
  onSubmit,
  onSelectReservation
}) {
  return (
    <Card className={classes.card} raised>
      <CardHeader
        title="Checkin"
        subheader={translate('findYourReservationByNameOrEmail')}
      />
      <CardContent width="100%">
        <TextField
          error={error}
          id="searchEmail"
          label={translate('txtEmail')}
          className={classes.textField}
          value={searchEmail}
          helperText={errorText}
          onChange={onChangeSearchEmail}
          margin="normal"
          onKeyPress={onKeyPress}
        />
        <CardActions className={classes.actions}>
          <Fab
            variant="extended"
            aria-label="Seguindo"
            className={classes.fab}
            onClick={onSubmit}
          >
            <ExpandMoreIcon className={classes.extendedIcon} />
            {translate('search')}
          </Fab>
        </CardActions>
        {reservationLoaded && (
          <TableContainer component={Paper}>
            <Table style={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{translate('tableHeaderName')}</TableCell>
                  <TableCell>{translate('tableHeaderResId')}</TableCell>
                  <TableCell>{translate('tableHeaderCheckin')}</TableCell>
                  <TableCell>{translate('tableHeaderCheckout')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reservationList.map((row) => (
                  <TableRow
                    key={row.name}
                    className={classes.tableRowHandle}
                    onClick={() => onSelectReservation(row)}
                  >
                    <TableCell>
                      {row.name} {row.surname}
                    </TableCell>
                    <TableCell>{row.property_booking_id}</TableCell>
                    <TableCell>{row.check_in_date}</TableCell>
                    <TableCell>{row.check_out_date}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  )
}

const styles = (theme) => ({
  card: {
    maxWidth: 800,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  textField: {
    marginTop: 0,
    marginLeft: 0,
    marginRight: theme.spacing(1),
    width: '100%'
  },
  actions: {
    display: 'flex',
    padding: '16px'
  },
  fab: {
    margin: theme.spacing(1),
    marginLeft: 0
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  tableRowHandle: {
    cursor: 'pointer'
  }
})

export default withStyles(styles)(withTranslate(FindReservationByEmailCard))
